<template lang="html">
  <header
    :class="['header', 'js-transition_item_common', { 'is-map': isMap() }]"
  >
    <div class="header__title">
      <div class="tit">
        <router-link :to="{ name: 'home' }"><LOGO class="logo"/></router-link>
      </div>
    </div>
  </header>
</template>

<script>
import LOGO from "./assets/logo.svg";

export default {
  components: {
    LOGO
  },
  props: {},
  methods: {
    isMap() {
      return this.$route.path == "/map";
    }
  },
  computed: {}
};
</script>

<style lang="scss" scoped>
@function fs($point) {
  @return ($point/10) * 1rem;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 50px;

  &.is-map {
    opacity: 0;
    pointer-events: none;
  }

  @include max(870) {
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }

  &__txtbox {
    color: #707070;
    text-align: right;
    margin-left: 30px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    @include max(870) {
      text-align: left;
      margin-left: 0;
      margin-top: 30px;
    }
  }

  .logo {
    color: #ebebeb;
  }

  .tit {
    font-size: 0;
    width: 160px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Common/Header/_index.vue